var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoneInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F4EBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.25C10.4072 17.248 11.0583 17.3759 11.6659 17.6264C12.2734 17.877 12.8254 18.2452 13.2901 18.7099C13.7548 19.1746 14.1231 19.7266 14.3736 20.3342C14.6241 20.9417 14.7521 21.5928 14.75 22.25",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 13.5C12.0706 13.5 14.2962 14.4219 15.9372 16.0628C17.5781 17.7038 18.5 19.9294 18.5 22.25",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 9.75002C11.3918 9.74693 13.018 10.0691 14.5346 10.698C16.0511 11.3269 17.4281 12.2501 18.5859 13.4141C19.75 14.5719 20.6731 15.9489 21.302 17.4655C21.9309 18.9821 22.2531 20.6082 22.25 22.25",
    stroke: "#8952E0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 22.875C10.5803 22.875 11 22.4553 11 21.9375C11 21.4197 10.5803 21 10.0625 21C9.54473 21 9.125 21.4197 9.125 21.9375C9.125 22.4553 9.54473 22.875 10.0625 22.875Z",
    fill: "#8952E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoneInfo);
export default __webpack_public_path__ + "static/media/zone-info.e16ca189f1047773a34357d4fb6bec4a.svg";
export { ForwardRef as ReactComponent };